import { getLang, useI18nContext } from "@hopper-b2b/i18n";

const formatterCache = new Map<string, Intl.NumberFormat>();

export const useNumberFormatter = () => {
  const { language } = useI18nContext();
  const locale = getLang(language);

  let formatter = formatterCache.get(locale);

  if (!formatter) {
    formatter = new Intl.NumberFormat(locale);
    formatterCache.set(locale, formatter);
  }

  return formatter;
};
